import { Image, QuestionLanguage } from "../../../../types/admin";
import ImageField from "../../ImageField";

interface Props {
    active_languages: string[];
    language: string;
    is_draft: boolean;
    default_image: Image | null;
    languages: QuestionLanguage[];
    handleLanguageImageChange: (image: File | null, language: string) => void;
    handleDefaultImageChange: (image: File | null) => void;
}

const MediaEditImage = ({
    active_languages,
    language,
    default_image,
    languages,
    handleLanguageImageChange,
    handleDefaultImageChange
}: Props) => {
    return (
        <>
            <ImageField
                defaultImage={default_image}
                setImage={handleDefaultImageChange}
                label='Oletuskuva'
            />
            {active_languages.map(lang => {
                const languageImage = languages.find((l) => l.language_code === lang)?.image || null;
                return (
                    <div key={lang} style={{ display: lang === language ? 'block' : 'none' }}>
                        <ImageField
                            defaultImage={languageImage}
                            setImage={(image) => handleLanguageImageChange(image, lang)}
                            label={`Kielikohtainen kuva (${lang.toUpperCase()})`}
                        />
                    </div>
                );
            })}
        </>
    )
}

export default MediaEditImage;